<template>
  <div class="page-old-car">
    <v-touch class="swipe-block" v-on:swiperight="onSwipeRoght"></v-touch>
    <!--    <vue-headful :title="getTitle" description="Description from vue-headful"/>-->
    <div class="container car-view car-page" v-if="loaded">
      <div class="main-header">
        <CarBreadCrumbs :car="car" :loaded="true"/>

        <div class="main-header-right">
          <span class="main-header-right-data">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                width="16px"
                height="16px"
            >
              <path
                  fill="#000"
                  fill-rule="nonzero"
                  d="M12.8596879 7.9649362c0-.3370213-.2697305-.6100426-.6022127-.6100426H8.57225532V3.6750071c0-.338156-.27438298-.6124255-.61231206-.6124255-.33815603 0-.612539.2742695-.612539.6124255v4.2875461c0 .3382695.27438297.612539.612539.612539h4.29787234c.3321418 0 .6018723-.2731348.6018723-.610156m1.8390922-.0038582c0 3.7217589-3.0166241 6.7388369-6.73758861 6.7388369-3.72119149 0-6.73758865-3.017078-6.73758865-6.7388369 0-3.7217589 3.01639716-6.73883687 6.73758865-6.73883687 3.72096451 0 6.73758861 3.01707797 6.73758861 6.73883687m1.2233759 0C15.922156 3.5642553 12.3579007 0 7.96119149 0 3.56425532 0 0 3.5642553 0 7.961078c0 4.3968227 3.56425532 7.961078 7.96119149 7.961078 4.39670921 0 7.96096451-3.5642553 7.96096451-7.961078"
                  opacity=".2"
              />
            </svg>
            <span>
              Á söluskrá í
              <b>{{ daysInSale }} daga</b>
            </span>
          </span>
          <span class="main-header-right-data">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 16"
                width="24px"
                height="16px"
            >
              <path
                  fill="#000"
                  fill-rule="nonzero"
                  d="M12.012 0C4.075 0 0 8 0 8s3.075 8 12.012 8c8.093 0 12.011-7.969 12.011-7.969S20.074 0 12.012 0zm.018 13c-2.902 0-5-2.188-5-5 0-2.813 2.098-5 5-5s5 2.187 5 5c0 2.812-2.098 5-5 5zm0-8c-1.658.003-3 1.393-3 3 0 1.606 1.342 3 3 3s3-1.395 3-3c0-1.608-1.342-3.003-3-3z"
                  opacity=".2"
              />
            </svg>
            <span>{{ car.views }}</span>
          </span>

          <span v-if="showSearch" class="main-header-right-data">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 29 29"
                width="29px"
                height="29px"
            >
              <g fill="none" fill-rule="evenodd">
                <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
                <path
                    fill="#FFF"
                    fill-rule="nonzero"
                    d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"
                />
              </g>
            </svg>
            <span>
              <b>
                Síðast uppfært
                <span
                    class="data-update-car"
                    :class="{ 'b-empty shine-short': !loaded }"
                >
                  {{ dayDiff }}
                </span>
                dögum
              </b>
            </span>
          </span>

          <span>
            <b>Vakta verð á ökutæki</b>
          </span>

          <SaveSearch
              v-if="showSearch"
              :car_id="id"
              :sub="sub"
              :subscriber="subscriber"
          />
        </div>
      </div>
      <div class="mobile-main-header" :style="$store.state.isApp ? 'margin-top:30px;' : 'margin-top: 120px'">
        <div class="mobile-main-header-noti">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 29 29"
              width="29px"
              height="29px"
          >
            <g fill="none" fill-rule="evenodd">
              <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
              <path
                  fill="#FFF"
                  fill-rule="nonzero"
                  d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"
              />
            </g>
          </svg>
          <span>Vakta verð á ökutæki</span>
        </div>
        <SaveSearch :car_id="id" :subscriber="subscriber"/>
      </div>

      <div class="main-content">
        <LightGal v-if="car.carsPhotos" :photos="car.carsPhotos" :car="car"/>

        <div class="mobile-main-meta" style="width: 100%">
          <span class="mobile-main-meta-item">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                width="16px"
                height="16px"
            >
              <path
                  fill="#000"
                  fill-rule="nonzero"
                  d="M12.8596879 7.9649362c0-.3370213-.2697305-.6100426-.6022127-.6100426H8.57225532V3.6750071c0-.338156-.27438298-.6124255-.61231206-.6124255-.33815603 0-.612539.2742695-.612539.6124255v4.2875461c0 .3382695.27438297.612539.612539.612539h4.29787234c.3321418 0 .6018723-.2731348.6018723-.610156m1.8390922-.0038582c0 3.7217589-3.0166241 6.7388369-6.73758861 6.7388369-3.72119149 0-6.73758865-3.017078-6.73758865-6.7388369 0-3.7217589 3.01639716-6.73883687 6.73758865-6.73883687 3.72096451 0 6.73758861 3.01707797 6.73758861 6.73883687m1.2233759 0C15.922156 3.5642553 12.3579007 0 7.96119149 0 3.56425532 0 0 3.5642553 0 7.961078c0 4.3968227 3.56425532 7.961078 7.96119149 7.961078 4.39670921 0 7.96096451-3.5642553 7.96096451-7.961078"
                  opacity=".2"
              />
            </svg>
            <span>
              Á söluskrá í
              <b>
                {{ daysInSale }}                daga
              </b>
            </span>
          </span>
          <span class="mobile-main-meta-item">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 16"
                width="24px"
                height="16px"
            >
              <path
                  fill="#000"
                  fill-rule="nonzero"
                  d="M12.012 0C4.075 0 0 8 0 8s3.075 8 12.012 8c8.093 0 12.011-7.969 12.011-7.969S20.074 0 12.012 0zm.018 13c-2.902 0-5-2.188-5-5 0-2.813 2.098-5 5-5s5 2.187 5 5c0 2.812-2.098 5-5 5zm0-8c-1.658.003-3 1.393-3 3 0 1.606 1.342 3 3 3s3-1.395 3-3c0-1.608-1.342-3.003-3-3z"
                  opacity=".2"
              />
            </svg>
            <span>{{ car.views }}</span>
          </span>
        </div>
        <div class="main-base-right-side">
          <CarSideInfo :car="convertCarData" :ad="ad" :loaded="loaded"/>
        </div>
      </div>
      <div class="main-description-wrap">
        <div class="main-description-promo">
          <car-page-ad v-if="ad && !watchAd" :ad="ad"/>
          <!--                <img src="mock/promoBig.png" alt="">-->
        </div>
        <div class="main-description old-car__description-content">
          <template v-if="car.aukahlutirath">
            <div class="car__description-title">Nánari upplýsingar</div>
            <div class="car__description-text">{{ car.aukahlutirath }}</div>
          </template>
          <TagsList :items="car.aukahlutir_main"/>

          <hr class="hr" v-if="hasAccessories"/>

          <CarAccordion
              v-if="hasAccessories"
              :items="accessories"
              :showAll="showAllInfo"
              :isOld="true"
          />

          <div class="dealer-car-packs__btn-wrapper">
            <div class="btn-more" @click="showHideAll()">
              {{ titleShowAllBtn }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--
        <Calculator
            v-if="loaded && showCalculator"
            :priceValue="price"
            :electroCar="isElectroCar"
            :hybridCar="isHybridCar"
            :co2="getCo2"
        />

-->
        <Calculator
            v-if="loaded && showCalculator"
            :title="'Reiknivél'"
            :electro-car="isElectroCar"
            :hybrid-car="isHybridCar"
            :co2="car.co2"
            :old-car-price="car.verd * 1000"
            :car-id="car.id"
            :dev-mode="true"
            :car-year="car.argerd"
            :thumbnail="convertCarData.thumbnail"
        ></Calculator>
    <div class="container car-view" v-if="loaded">
      <div class="main-description-wrap">
        <div class="main-description-promo"></div>
        <div class="main-description old-car__description-content">
          <div class="panorama-car" v-if="car.panorama_image_url">
            <iframe
                :src="car.panorama_image_url"
                class="car-360"
            ></iframe>
          </div>
          <LightGalleryThumbnails :items="convertCarsPhoto"/>
        </div>
      </div>
    </div>

    <div
        class="container car-view contact-form-anchor"
        id="scroll-contact-form"
    >
      <div class="main-description-wrap">
        <div class="main-description-promo">
          <!-- <img src="mock/promoBig.png" alt="">-->
        </div>
        <transition name="fade" :duration="800">
          <div
              class="block-hidden-before-loaded-data section-content"
              v-if="loaded"
          >
            <ContactForm
                :key="contactFormKey"
                :car="convertCarData"
                :brandUrl="brand_url"
                :entry-car-id="parseInt(car.api_id)"
                oldCar
                ref="contactFormCar"
            />
          </div>
        </transition>
      </div>
    </div>

    <div class="container car-view" v-if="loaded">
      <div class="main-header main-description-details-breadcrumbs show-on-mobile">
        <CarBreadCrumbs :car="car" :loaded="loaded"/>
      </div>

      <div class="main-description-details">
        <DealerCarsSlider :scar="convertSimilarCarsData"/>
      </div>
    </div>
    <Footer class="footer-main" v-if="isIosApp"/>
  </div>
</template>

<script>
import globalNewCar from "@/helpers/globalNewCar";
import scroll from "../helpers/scroll";


import SaveSearch from "@/components/SaveSearch";
import LightGal from "@/components/LightGal";
import ContactForm from "@/components/Dealers/ContactForm";
import CarAccordion from "@/components/OldCars/CarAccordion";
import TagsList from "@/components/OldCars/TagsList";
import DealerCarsSlider from "@/components/Dealers/DealerCarsSlider";
import CarSideInfo from "@/components/OldCars/CarSideInfo/_index";
import LightGalleryThumbnails from "@/components/OldCars/LightGalleryThumbnails";
import CarBreadCrumbs from "@/components/OldCars/CarBreadCrumbs";
import Footer from "@/components/Footer";

//Mixins
import libs from "@/mixins/libs";
import oldCar from "@/mixins/oldCar";
import oldCars from "@/mixins/oldCars";

import routesNames from "@/router/constants";
import {mapActions, mapGetters, mapState} from "vuex";
import CarPageAd from "@/components/global/CarPageAd";
import getBaseUrl from "@/helpers/getBaseUrl";
//import { Calculator } from "@studiomango/calculator"
import Calculator from "@/components/Dealers/Calculator";


export default {
  metaInfo() {
    return {
      title: this.getTitle,
      titleTemplate: '%s | bilaskra.is',
      meta: this.getMeta,
      link: [
        {
          rel: 'canonical',
          href: getBaseUrl() + this.$route.fullPath
        }
      ],
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  },
  components: {
    CarPageAd,
    SaveSearch,
    LightGal,
    ContactForm,
    CarAccordion,
    TagsList,
    DealerCarsSlider,
    CarSideInfo,
    Calculator,
    LightGalleryThumbnails,
    CarBreadCrumbs,
    Footer,
  },
  mixins: [libs, oldCar, oldCars],
  data: () => ({
    contactFormKey: 0,
    sub: null,
    subscriber: null,
    cars: null,
    car: null,
    fuelTypes: [],
    loaded: false,
    showAllInfo: false,
    brand_url: "",
    brand_model_url: "",
    year_url: "",
    category_url: "",
    ad: null,
    watchAd: false
  }),
  methods: {
    ...mapActions({
      'getAd': "ad/GET"
    }),
    scrollUp() {
      scroll.to(0);
    },
    getData() {
      this.$http
          .post(`${this.$store.state.api}/old-cars/get-car`, {
            car_id: this.id,
            view_key: localStorage.getItem('view_key')
          })
          .then((response) => {
                if (!response.body) return;

                this.watchAd = false;
                // Car
                if (typeof response.body.car != "undefined") {
                  // const car = response.body.car
                  this.car = response.body.car;

                  localStorage.setItem("view_key",this.car.views.view_key);
                  this.car.views = this.car.views.count;

                  for (let k in this.car.carsPhotos) {
                    let item = this.car.carsPhotos[k];
                    // item.big_photo = `${getBaseUrl()}/images/${item.file_name}.webp`;
                    item.big_photo = globalNewCar.getPicUrl(item.file_name);
                  }

                  this.brand_url = `${
                      routesNames.oldCars
                  }/${globalNewCar.setUrlParams({
                    brands: [this.car.brand_id],
                  })}`;

                  this.brand_model_url = `/${globalNewCar.setUrlParams({
                    brand_model: ["b" + this.car.ext_modgerdid],
                    brands: [this.car.ext_modframleidandiid],
                  })}`;

                  this.year_url = `/${globalNewCar.setUrlParams({
                    year: [this.car.argerd],
                  })}`;

                  this.category_url = `/${globalNewCar.setUrlParams({
                    category: [this.car.flokkur_id],
                  })}`;
                }

                // Cars
                if (typeof response.body.cars != "undefined") {
                  for (var k in response.body.cars) {
                    let fuelType = response.body.cars[k].ft;
                    response.body.cars[k].fuel_type = fuelType
                        ? response.body.fuel_type[fuelType].name
                        : "";
                  }
                  this.cars = response.body.cars;
                }

                // Fav
                if (response.body.fav && parseInt(response.body.fav) > 0) {
                  this.sub = response.body.fav;
                }
                this.$store.state.sub = parseInt(response.body.fav);

                this.fuelTypes = response.body.fuel_type;

                this.car.deleted = parseInt(this.car.deleted);

                this.$store.state.car_data = this.car;
                this.loaded = true;
                this.$store.state.moduleOldCars.carLoaded = true;


                document.dispatchEvent(new Event('renderer-ready'));
              },
              (error) => {
                this.error = error;
                if (error.status === 404) {
                  this.$router.push(`${routesNames.oldCars}/not-found`);
                }
              }
          );
      window.scrollTo(0, top);
      this.scrollUp()
    },
    handleMore() {
      this.showAllInfo = true;
    },
    showHideAll() {
      this.showAllInfo = !this.showAllInfo;
    },
    onSwipeRoght() {
      let props = this.$router.resolve({name: "OldCars"});
      let url = props.href + window.location.search;

      if (this.$route.fullPath != url) {
        this.$router.push(url);
      }
    },
  },
  computed: {
    ...mapGetters(["isIosApp"]),
    ...mapState({
      pageLocationId: (state) => state.ad.pageLocationId,
    }),
    id() {
      return this.$route.params.id
    },
    dayDiff() {
      return this.moment().diff(this.moment(this.car.lastupdated, "YYYY-MM-DD"), "days");
    },
    hasAccessories() {
      return Object.keys(this.accessories).length
    },
    createdDaysAgo() {
      return this.moment().diff(this.moment(this.car.fyrstiskrdagur, "YYYY-MM-DD"), "days")
    }
  },
  beforeRouteLeave(to,from,next){
    if(to.name != "OldCars"){
      this.$store.state.oldCarsPosition = 0;
      this.$store.state.oldCarsLoadedCars = [];
    }
    next();
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.contactFormKey += 1;
        this.watchAd = true;

        this.getAd({location: this.pageLocationId,isUsed:1}).then(res => {
          if (res && res.data.status) {
            this.ad = res.data.ad;
          }
          this.getData();
        });
      }
    },
  }
};
</script>
